import { FC, useState } from 'react'
import { generatePath, Link } from 'react-router'

import { Carousel, Col, Flex, Layout, List, Row, Spin, Tabs, Typography } from 'antd'
import { useResponsive } from 'antd-style'

import { Page } from '../../components/page'
import { Title } from '../../components/text/Title'
import { useArticlesQuery } from '../../graphql'
import routes from '../../routes'
import { ArticleCard } from '../blog/ArticleCard'

import { LatestVideosList } from './LatestVideosList'

const Home: FC = () => {
  const { mobile } = useResponsive()
  const { data, loading } = useArticlesQuery()
  const [activeKey, setActiveKey] = useState<string>('all')

  const articles = Array.from(data?.articles ?? [])
    .filter((it) => it?.pinned === false)
    .filter((it) => (activeKey !== 'all' ? it?.category?.slug === activeKey : true))
  const categories = (data?.articles ?? [])
    .map((it) => it?.category)
    .map((it) => ({ [`${it?.documentId}`]: it }))
    .reduce((each, all) => ({ ...each, ...all }), {})
  const pinnedArticles = data?.articles?.filter((it) => it?.pinned) ?? []
  const tabs = [{ label: 'Всі', key: 'all' }].concat(
    ...Object.values(categories).map((it) => ({
      label: it?.name ?? '',
      key: it?.slug ?? '',
    })),
  )
  return (
    <Page>
      <Layout.Content>
        <Flex vertical gap={16}>
          <Row gutter={16}>
            <Col xs={24} md={12} lg={16}>
              <Carousel
                lazyLoad={'ondemand'}
                style={{ height: mobile ? 300 : 504 }}
                draggable
                adaptiveHeight={false}
                swipeToSlide
                arrows={true}
                dots={false}
              >
                {(loading
                  ? [
                      {
                        documentId: '',
                        teaser: '',
                        cover: undefined,
                        title: '',
                        slug: '',
                      },
                    ]
                  : pinnedArticles
                ).map((it) => {
                  return (
                    <div key={it?.documentId} style={{ width: '100%' }}>
                      <Flex vertical style={{ width: '100%', padding: 24, height: 88 }}>
                        <Flex gap={4} vertical>
                          <Title style={{ marginBottom: 0 }} level={4}>
                            <Link to={generatePath(routes.article, { slug: `${it?.slug}` })}>{it?.title}</Link>
                          </Title>
                          <Typography.Text ellipsis>{it?.teaser}</Typography.Text>
                        </Flex>
                      </Flex>
                      {loading ? (
                        <Flex align={'center'} justify={'center'} style={{ width: '100%', height: mobile ? 200 : 416 }}>
                          <Spin size={'small'} />
                        </Flex>
                      ) : (
                        <img
                          loading={'lazy'}
                          height={400}
                          alt={it?.cover?.alternativeText ?? it?.title}
                          style={{ height: mobile ? 200 : 416, width: '100%', objectFit: 'cover' }}
                          src={mobile ? it?.cover?.formats?.small.url : it?.cover?.formats?.medium?.url}
                        />
                      )}
                    </div>
                  )
                })}
              </Carousel>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <LatestVideosList pageSize={2} />
            </Col>
          </Row>
          <Tabs
            defaultActiveKey={'all'}
            items={tabs.map((it) => ({
              ...it,
              children: (
                <List
                  loading={loading}
                  grid={{ gutter: 16, xs: 1, sm: 2, md: 2, lg: 3, xl: 3, xxl: 3 }}
                  dataSource={articles}
                  pagination={{ pageSize: 6, hideOnSinglePage: true }}
                  renderItem={(it) =>
                    it && (
                      <List.Item>
                        <ArticleCard {...it} />
                      </List.Item>
                    )
                  }
                />
              ),
            }))}
            onChange={setActiveKey}
          />
        </Flex>
      </Layout.Content>
    </Page>
  )
}

export default Home
